import moment from 'moment';

export default {
  methods: {
    getLocalTimeFromUTC(utcTime) {
      return moment.utc(utcTime).local().format('YYYY-MM-DD HH:mm:ss');
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const formattedDate = date.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });
      return formattedDate;
    },
    getLocalTimeSlashFormat(utcTime) {
      return moment.utc(utcTime).local().format('DD/MM/YYYY');
    },
    getLocalTimeDashFormat(utcTime) {
      return moment.utc(utcTime).local().format('YYYY-MM-DD');
    }
  }
}